<button
  type="button"
  (click)="clicked.emit()"
  [disabled]="disabled() || loading()"
  [class]="
    'px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-main focus:ring-offset-2 flex items-center justify-center gap-2 ' +
    (fullWidth() ? 'w-full ' : '') +
    (!disabled() && !loading()
      ? 'border-main text-main border hover:text-white hover:bg-main/90'
      : 'bg-gray-300 text-gray-500 cursor-not-allowed')
  ">
  @if (loading()) {
    <svg
      class="w-4 h-4 animate-spin text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
    </svg>
    <span>{{ loadingLabel() ?? label() }}</span>
  } @else {
    <span>{{ label() }}</span>
  }
</button>
